import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExampleGridWidgetComponent } from './example-grid-widget.component';
import {DxDataGridModule} from 'devextreme-angular';



@NgModule({
  declarations: [ExampleGridWidgetComponent],
    imports: [
        CommonModule,
        DxDataGridModule
    ],
  exports: [ExampleGridWidgetComponent]
})
export class ExampleGridWidgetModule { }
